import React, { forwardRef } from 'react';
import classNames from 'classnames';
import Radio, { RadioProps } from '../../atoms/radio/Radio';
import ErrorMessage, { Errors } from '../../atoms/message/ErrorMessage';

interface Props extends RadioProps {
  options: {
    id: string;
    label: string;
    value: string | number;
  }[];
  error?: Errors;
  getTranslation?: (message: string) => string;
  className?: string;
}

// eslint-disable-next-line react/display-name
const RadioGroup = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      error,
      type,
      size,
      options = [],
      className,
      getTranslation,
      ...props
    }: Props,
    ref,
  ) => {
    return (
      <div>
        <div className={classNames('d-flex flex-wrap gap-12 mb-6', className)}>
          {options.map((item) => (
            <Radio
              key={item.id}
              ref={ref}
              {...props}
              id={item.id}
              name={name}
              size={size}
              type={type}
              label={item.label}
              value={item.value}
            />
          ))}
        </div>
        <ErrorMessage
          name={name}
          errors={error}
          getTranslation={getTranslation}
        />
      </div>
    );
  },
);

export default RadioGroup;
